import Base from './Base';
import CompanyModel from './Company';

export default class PaginationModel extends Base  {
	public current_page: number;
	public last_page: number;
	public per_page: number;
	public total: number;
	
	constructor(data?: object) {
		super(null);

		this.current_page = 1;
		this.last_page = 1;
		this.total = 0;
		this.addData(data);
	}



	
}